/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RegisterDeviceTokenDto = {
    /**
     * FCM/APNs/Expo push notification token
     */
    device_token: string;
    /**
     * Device type
     */
    device_type: RegisterDeviceTokenDto.device_type;
    /**
     * Device name
     */
    device_name?: string;
    /**
     * App version
     */
    app_version?: string;
    /**
     * OS version
     */
    os_version?: string;
};
export namespace RegisterDeviceTokenDto {
    /**
     * Device type
     */
    export enum device_type {
        IOS = 'ios',
        ANDROID = 'android',
        WEB = 'web',
    }
}

